module.exports = __webpack_public_path__ + "img/type-style3.4c064c95.png";